import { render, staticRenderFns } from "./GCheckBox.vue?vue&type=template&id=133493f9&"
import script from "./GCheckBox.vue?vue&type=script&lang=js&"
export * from "./GCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports